// extracted by mini-css-extract-plugin
export var actionButton = "_du-0";
export var attachmentLine = "_du-1";
export var fileInput = "_du-2";
export var fileUploadWrapper = "_du-4";
export var footer = "_du-3";
export var modalContent = "_du-5";
export var paperclip = "_du-6";
export var quillEditor = "_du-7";